// SPDX-FileCopyrightText: 2026 mmayhew
// SPDX-License-Identifier: AGPL-3.0-only

import './core/state.js';
import './core/config.js';
import './core/dom.js';
import './ui/ui_helpers.js';
import './ui/ui_pressable.js';
import './ui/ui_disclosure.js';
import './ui/ui_dismissible.js';
import './ui/ui_focus_trap.js';
import './ui/mobile_sheet.js';
import './ui/ui_action_sheet.js';
import './ui/ui_confirm.js';
import './ui/ui_outside_click.js';
import './ui/ui_tab_strip_edges.js';
import './ui/ui_entity_metadata.js';
import './core/lazy_assets.js';
import './core/utils.js';
import './core/run_output_model.js';
import './core/session_core.js';
import './session.js';
import './core/history_core.js';
import './core/workspace_core.js';
import './core/runner_core.js';
import './core/output_core.js';
import './output.js';
import './features/command-registry/faq_helpers.js';
import './features/team_scope.js';
import './features/projects/project_target_validation.js';
import './features/projects/project_workspace_constants.js';
import './features/projects/project_workspace_state.js';
import './features/projects/project_active_context.js';
import './features/projects/project_shared_ui.js';
import './features/findings/finding_triage_bridge.js';
import './features/terminal/composer_editing.js';
import './features/shortcuts/global_shortcuts.js';
import './features/shortcuts/shortcuts_key_handler.js';
import { openOptions } from './app.js';
import './features/terminal/local_commands.js';
import './features/mobile/mobile_shell_layout.js';
import './features/terminal/mobile_composer_keyboard.js';
import './core/autocomplete_core.js';
import './features/autocomplete/suggestions.js';
import './autocomplete.js';
import './features/autocomplete/runtime_context.js';
import './tabs.js';
import './history.js';
import './features/history/history_project_actions.js';
import './features/history/history_recall.js';
import './features/history/history_actions.js';
import './features/history/history_links.js';
import './features/history/history_search.js';
import './features/history/history_mutations.js';
import './features/history/history_rows.js';
import './features/history/history_restore.js';
import './export_html_bridge.js';
import './welcome.js';
import './features/tabs/tab_exports.js';
import './features/tabs/tab_drag_reorder.js';
import './features/tabs/tab_close_lifecycle.js';
import './features/tabs/tab_session_state.js';
import './core/search_core.js';
import './search.js';
import './features/theme/theme.js';
import './core/app_preferences_core.js';
import './features/preferences/preferences.js';
import './features/workspace/workspace_autocomplete_cache.js';
import './features/mobile/mobile_menu_actions.js';
import './features/runner/runner_active_restore.js';
import './features/runner/runner_workspace.js';
import './features/runner/runner_persistence.js';
import './runner.js';
import { shellStartup } from './controller.js';
import './features/terminal/composer_controller.js';
import './e2e_test_hooks_loader.js';
import './shell_chrome.js';
import './mobile_chrome.js';

// Sign-in can return directly to Access after the shell and panel handlers load.
const initialLocation = new URL(window.location.href);
if (initialLocation.searchParams.get('options') === 'access') {
  initialLocation.searchParams.delete('options');
  window.history.replaceState(window.history.state, '', initialLocation.href);
  void shellStartup.ready.then(() => openOptions({ tab: 'access' }));
}
